module.exports = __webpack_public_path__ + "static/media/logo_icon.7c8bc71e.svg";